<template>
  <v-app>
    <router-view> </router-view>
  </v-app>
</template>

<script>

export default {
	name: 'App',

	components: {
	},
	data: () => ({
		//
	})
}
</script>
<style>
.v-application .blue {
  background-color: #FFF !important;
  border-color: #FFF !important;
}
</style>
